import { Button, Flex, Heading, Text } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { SignUpContext } from '@/containers/SignUp/components/SignUpContext';
import { IToastType } from '@/enums/ToastType';
import { useStores } from '@/hooks/useStores';
import { useToast } from '@/hooks/useToast';

export const SuccessStep = () => {
  const { signUpProps } = useContext(SignUpContext);
  const { store } = useStores();
  const toast = useToast();
  const { t } = useTranslation();
  const router = useRouter();

  const handleResendEmail = async () => {
    const { email } = signUpProps;

    try {
      await store.request('confirmation', 'POST', {
        data: {
          type: 'confirmation',
          id: '',
          attributes: {
            email,
          },
        },
      });
      toast({ status: IToastType.INFO, title: t('createAccount.toast.resendEmail') });
    } catch (error) {
      toast({ status: IToastType.ERROR, title: t('createAccount.toast.error') });
    }
  };

  const handleClose = () => {
    router.push('/');
  };

  return (
    <Flex w="full" justifyContent="space-around" flexDirection={{ base: 'column', lg: 'row' }}>
      <Flex mb={14} maxW="390px" flexDirection="column" flex={1}>
        <Text color="gray.600">{`3 / 3`}</Text>
        <Heading mt={8} fontSize="5xl">
          {t('createAccount.success.title')}
        </Heading>
        <Text mb={8} mt={12}>
          {t('createAccount.success.message', { email: signUpProps?.email })}
        </Text>
        <Trans
          i18nKey="createAccount.success.failureQuestion"
          components={{
            text1: <Text color="gray.600" />,
            text2: <Text mt={4} margin="12px 0 32px" color="gray.600" />,
            button: <Button variant="link" color="black" ml={2} onClick={handleResendEmail} />,
          }}
        />
        <Button alignSelf="flex-start" variant="outline" onClick={handleClose}>
          {t('createAccount.success.action')}
        </Button>
      </Flex>
      <Flex flexDirection="column" maxW="390px" flex={1}></Flex>
    </Flex>
  );
};
